import { EntryProps, getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

export const ConversationOfferResponse = ({
  entry,
}: EntryProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : null;

  const action =
    entry.activity_type === 'CONVERSATION_OFFER_ACCEPTED'
      ? 'accepted'
      : 'rejected';

  const text = (
    <>
      Conversation is {action} {authorLink && <>by {authorLink}</>}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
